module.exports = __webpack_public_path__ + "static/img/webinars2.4470690.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mastheads/webinars2.jpg
// module id = EPk+
// module chunks = 1